import { createContext } from 'react';

import { RootAccessRoles } from 'core/dna/types/access-roles';

export const AccessRolesStateContext = createContext<RootAccessRoles[] | null>(
  null,
);

AccessRolesStateContext.displayName = 'AccessRolesState Context';
